import * as React from 'react';
import clsx from 'clsx';
import { MicrophoneIcon } from '@heroicons/react/24/outline';

interface VoiceCloneCardProps {
  onClick?: () => void;
  disabled?: boolean;
}

/** Card to initiate voice cloning flow. */
export const VoiceCloneCard: React.FC<VoiceCloneCardProps> = ({ onClick, disabled }) => (
  <button
    type='button'
    onClick={onClick}
    disabled={disabled}
    aria-label='Clone your voice'
    className={clsx(
      'flex w-full flex-col items-center justify-center gap-3',
      'h-[198px] xl:w-[340px]',
      'rounded-20 border border-dashed border-gray-535 bg-gray-150',
      'transition-transform hover:scale-[1.01] active:scale-95 disabled:opacity-50'
    )}
  >
    <div className='flex size-[40px] items-center justify-center rounded-full bg-white/70'>
      <MicrophoneIcon className='size-6 text-dark-200' />
    </div>

    <span className='font-sans text-20 font-medium leading-27 tracking-normal text-dark-300'>
      Clone Your Voice
    </span>
  </button>
);
